import { render, staticRenderFns } from "./AITestSupport.vue?vue&type=template&id=2ebd41b9&scoped=true&"
import script from "./AITestSupport.vue?vue&type=script&lang=js&"
export * from "./AITestSupport.vue?vue&type=script&lang=js&"
import style0 from "./AITestSupport.vue?vue&type=style&index=0&id=2ebd41b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd41b9",
  null
  
)

export default component.exports